import {
    CLAUSE_LIST,
    CLAUSES_CATEGORY_TYPE_LIST,
    CLAUSE_TYPE_LIST,
    CLAUSE_PAGINATION
} from './constant';

export const initStateFeed = {
    clauseList: [],
    clausesCategoryTypeList: [],
    clauseTypeList: [],
    pagination: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case CLAUSE_LIST: {
            return {
                ...state,
                clauseList: action.payload,
            };
        }
        case CLAUSES_CATEGORY_TYPE_LIST: {
            return {
                ...state,
                clausesCategoryTypeList: action.payload,
            };
        }
        case CLAUSE_TYPE_LIST: {
            return {
                ...state,
                clauseTypeList: action.payload,
            };
        }
        case CLAUSE_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        default:
            return state;
    }
};
 